import { Button } from "@maker/design-system/ui/button";
import { cn } from "@maker/utils/cn";
import {
	CalendarClockIcon,
	FileVideoCameraIcon,
	ScrollTextIcon,
} from "lucide-react";
import { NavLink } from "react-router";

type NavbarLinkProps = {
	pathname: string;
	disabled?: boolean;
	children: React.ReactNode;
};

const menus = [
	{
		pathname: "/",
		icon: <FileVideoCameraIcon size={16} strokeWidth={1.75} />,
		text: "Transcrições",
	},
	{
		pathname: "/processes",
		icon: <ScrollTextIcon size={16} strokeWidth={1.75} />,
		text: "Processos",
		disabled: true,
	},
	{
		pathname: "/dates",
		icon: <CalendarClockIcon size={16} strokeWidth={1.75} />,
		text: "Prazos",
		disabled: true,
	},
];

const NavbarLink = ({ pathname, disabled, children }: NavbarLinkProps) => {
	return (
		<Button
			modifier="ghost"
			nativeButton={false}
			disabled={disabled}
			render={(props) => (
				<NavLink
					{...props}
					to={{ pathname }}
					className={() =>
						cn(
							props.className,
							"flex items-center gap-2 rounded-lg p-2 text-neutral-500 text-sm hover:text-neutral-900",
							{
								"pointer-events-none bg-neutral-200/50 text-neutral-900":
									pathname === "/",
							},
							{
								"cursor-not-allowed": disabled,
							},
						)
					}
				/>
			)}
		>
			{children}
		</Button>
	);
};

const Navbar = () => {
	return (
		<nav className="space-y-1 px-4">
			{menus.map((menu) => (
				<NavbarLink
					pathname={menu.pathname}
					key={menu.pathname}
					disabled={menu.disabled}
				>
					{menu.icon}

					<span>{menu.text}</span>
				</NavbarLink>
			))}
		</nav>
	);
};

export { Navbar };
